import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import CheckMarkSVG from '../../../../public/static/icons/checkMark.svg';

export const StyledOfferBoardCard = styled.article`
    color: ${(props) => props.theme.shades.darkGrey};
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    margin-bottom: 20px;

    @media ${mediaQueries.tablet} {
        /* 2 columns */
        width: calc(1 / 2 * 100%);
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        /* 3 columns */
        width: calc(1 / 3 * 100%);
    }

    @media ${mediaQueries.IE10or11} {
        width: 33%;
    }
`;

export const StyledTopSection = styled.div`
    position: relative;
`;

export const StyledImageWrapper = styled.div`
    width: 100%;
    overflow: hidden;
`;

export const StyledCompanyLogoWrapper = styled.div`
    width: 98px;
    height: 60px;
    background-color: white;
    position: absolute;
    bottom: 9px;
    text-align: center;
`;

export const StyledImage = styled.img`
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
`;

export const StyledAspectRatio = styled.div`
    position: relative;

    &::before {
        position: relative;
        display: block;
        content: '';
        padding-bottom: calc(225 / 350 * 100%);

        @media ${mediaQueries.smallDesktopAndUp} {
            padding-bottom: calc(225 / 370 * 100%);
        }
    }
`;

export const StyledContentWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;

    img {
        object-fit: cover;
        object-position: center center;
        height: 100%;
        width: 100%;
        user-select: none;
    }
`;

export const StyledInfoCardLink = styled.div`
    color: ${(props) => props.theme.shades.darkGrey};
    text-decoration: none;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    &:focus,
    &:active,
    &:visited,
    &:hover {
        color: ${(props) => props.theme.shades.darkGrey};
        text-decoration: none;
    }
`;

export const StyledButtonWrapper = styled.div`
    text-align: center;
    && div button span:first-child {
        padding-left: 12px !important;
    }
`;

export const StyledMiddleSection = styled.div`
    width: 100%;
    padding: ${(props) => `${props.theme.spacing.medium} ${props.theme.spacing.medium} 0`};
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

export const StyledFlex = styled.div`
    display: flex;
    justify-content: left;
    margin-top: ${(props) => props.theme.spacing.small};
`;

export const StyledFlexSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${(props) => props.theme.spacing.medium};
    /* To ensure that the title section grow accordingly */
    &:nth-of-type(2) {
        flex-grow: 1;
    }
`;

export const StyledMargin = styled.div`
    margin-bottom: ${(props) => props.theme.spacing.medium};
`;

export const StyledDurationInfo = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    color: ${(props) => props.theme.shades.blackGrey};
    font-weight: 600;
    line-height: 1.42;
`;

export const StyledEventsInfo = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    color: ${(props) => props.theme.shades.midGrey};
    padding-left: ${(props) => props.theme.spacing.medium};
`;

export const StyledOfferHeading = styled.a`
    display: flex;
    flex-grow: 1;
    font-size: ${(props) => props.theme.fontSize.headlineXS};
    color: ${(props) => props.theme.shades.blackGrey};
    line-height: 1.22;
    font-weight: 700;
    justify-content: center;
    text-align: center;
    margin: 0;
    &:focus,
    &:active,
    &:visited,
    &:hover {
        color: ${(props) => props.theme.shades.blackGrey};
        text-decoration: none;
    }
`;

export const StyledItineraryInfo = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextXS};
    color: ${(props) => props.theme.shades.midGrey};
    font-weight: 600;
`;

export const StyledBottomSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    margin: ${(props) => props.theme.spacing.medium} 0 ${(props) => props.theme.spacing.large};
    overflow: hidden;
`;

export const StyledTextLabelList = styled.ul`
    padding-left: ${(props) => props.theme.spacing.medium};
    list-style: none;
    display: flex;
    margin-top: ${(props) => props.theme.spacing.small};
    flex-wrap: none;
    overflow: hidden;
    max-width: 100%;
    flex-wrap: wrap;
    max-height: 25px;
    flex-direction: row;
`;

export const StyledTextLabelListItem = styled.li`
    margin-right: 3px;
    word-break: none;
    word-wrap: none;
    white-space: nowrap;

    & :last-child {
        margin-right: 0;
    }
`;

export const StyledMarketingLabels = styled.div`
    margin-top: 2px;
    display: flex;
    flex-shrink: 0;
    flex-direction: row;
    margin-right: auto;
`;

export const StyledMarketingOfferLabel = styled.div<{ color: string }>`
    background-color: ${(props: { color: string }) => props.color};
    height: 20px;
    font-size: 10px;
    font-weight: 600;
    color: ${(props) => props.theme.shades.white};
    margin-bottom: ${(props) => props.theme.spacing.small};
    margin-right: ${(props) => props.theme.spacing.small};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
`;

export const StyledUserLove = styled.span`
    font-size: ${(props) => props.theme.fontSize.copyTextS};
    padding-left: ${(props) => props.theme.spacing.medium};
    color: ${(props) => props.theme.shades.blackGrey};
    display: block;
`;

export const StyledCheckMarkIcon = styled(CheckMarkSVG)`
    fill: ${(props) => props.theme.labels.onlineBookable};
    height: 20px;
    width: 20px;
    margin-right: 5px;
`;

export const StyledIconList = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    padding: 0;
`;

export const StyledIconListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: left;
    width: 50%;
    padding: 3px 10px;
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    color: ${(props) => props.theme.shades.blackGrey};
    font-weight: 600;
    line-height: 1.42;
}
`;
